import React, {useState} from "react";
import {useForm} from "react-hook-form";
import SellerFields from "./SellerFields";

export default function () {
  const {register, handleSubmit, reset, control} = useForm();
  const [errors, setErrors] = useState({});

  const sellerFields = <SellerFields {...{register, errors, control}} />;

  return {
    setErrors,
    sellerFields,
    handleSubmit,
    reset,
  }
}